import React from 'react';
import { Helmet } from 'react-helmet';

const RefundPolicy = () => {
  return (
    <div style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif", lineHeight: '1.6', color: '#333', background: '#f5f5f5', minHeight: '100vh' }}>
      <Helmet>
        <title>Refund Policy | SugarHathi</title>
        <meta name="description" content="SugarHathi's refund and cancellation policy for platform transactions." />
      </Helmet>
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px', background: 'white', minHeight: '100vh' }}>

        <div style={{ textAlign: 'center', marginBottom: '40px', paddingBottom: '20px', borderBottom: '3px solid #2ecc71' }}>
          <h1 style={{ fontSize: '2.5rem', color: '#2ecc71', margin: '0 0 10px 0', padding: 0 }}>Refund & Cancellation Policy</h1>
          <p style={{ color: '#666', fontSize: '0.95rem', margin: '0 0 5px 0' }}><strong style={{ color: '#2c3e50' }}>Villgrains FarmTech Private Limited</strong></p>
          <p style={{ color: '#666', fontSize: '0.95rem', margin: 0 }}>Last Updated: June 7, 2026</p>
        </div>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>1. Cancellations</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            Bookings confirmed with payment cannot be cancelled by the buyer. In exceptional circumstances,
            cancellation requests may be considered at the sole discretion of Villgrains FarmTech Private Limited.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>2. Refunds</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            Refunds are applicable only in the following cases:
          </p>
          <ul style={{ margin: '15px 0 15px 30px' }}>
            <li style={{ marginBottom: '10px' }}>Factory is unable to supply the confirmed quantity.</li>
            <li style={{ marginBottom: '10px' }}>Duplicate payment made by the buyer.</li>
            <li style={{ marginBottom: '10px' }}>Technical error resulting in incorrect charge.</li>
          </ul>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            Approved refunds will be processed within <strong style={{ color: '#2c3e50' }}>7 working days</strong> to
            the original payment source.
          </p>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>3. Non-Refundable Items</h2>
          <ul style={{ margin: '15px 0 15px 30px' }}>
            <li style={{ marginBottom: '10px' }}>Tracking fee of ₹199 once the tracking link is activated.</li>
            <li style={{ marginBottom: '10px' }}>Service fees once the order is dispatched.</li>
          </ul>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>4. How to Request a Refund</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            To request a refund, contact us with your booking reference and payment details:
          </p>
          <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', margin: '15px 0' }}>
            <p style={{ marginBottom: '10px' }}><strong style={{ color: '#2c3e50' }}>Email:</strong> info@villagegrains.com</p>
            <p style={{ marginBottom: 0 }}><strong style={{ color: '#2c3e50' }}>WhatsApp:</strong> +91 79899 53468</p>
          </div>
        </section>

        <section>
          <h2 style={{ color: '#2ecc71', fontSize: '1.8rem', margin: '30px 0 15px 0', paddingTop: '20px' }}>5. Governing Law</h2>
          <p style={{ marginBottom: '15px', textAlign: 'justify' }}>
            This policy is governed by the laws of India. Disputes shall be subject to the jurisdiction
            of courts in Hyderabad, Telangana.
          </p>
        </section>

        <div style={{ textAlign: 'center', marginTop: '50px', paddingTop: '30px', borderTop: '2px solid #e0e0e0', color: '#666', fontSize: '0.9rem' }}>
          <p style={{ marginBottom: '5px' }}>&copy; 2026 Villgrains FarmTech Private Limited. All rights reserved.</p>
          <p style={{ margin: 0 }}>Trading as SugarHathi</p>
        </div>

      </div>
    </div>
  );
};

export default RefundPolicy;
